import React from 'react';
import { Checkbox } from '../..';
export const RowSelect = ({ onRowSelect, gridID, isSelected, rowID, selectionDisabled, }) => {
    const checkProps = {};
    if (onRowSelect) {
        if (typeof isSelected === 'boolean' && isSelected) {
            checkProps.checked = true;
            checkProps.indeterminate = false;
        }
        else if (typeof isSelected === 'string' && isSelected === 'indeterminate') {
            checkProps.indeterminate = true;
            checkProps.checked = false;
        }
        else {
            checkProps.checked = false;
            checkProps.indeterminate = false;
        }
    }
    const checkbox = (React.createElement(Checkbox, Object.assign({}, checkProps, { disabled: selectionDisabled, "aria-label": `Table row selection`, onClick: e => {
            if (onRowSelect) {
                if (rowID || (rowID === 0 && typeof rowID === 'number')) {
                    onRowSelect(e.shiftKey, rowID);
                }
                else {
                    onRowSelect(e.shiftKey, 0);
                }
            }
        } })));
    if (rowID >= 0) {
        return (React.createElement(React.Fragment, null,
            React.createElement("td", { className: "table_select" }, checkbox)));
    }
    else {
        return (React.createElement(React.Fragment, null,
            React.createElement("th", { className: "table_select" }, checkbox)));
    }
};
//# sourceMappingURL=RowSelect.js.map